import { useState } from 'react';
import { faqs } from '@/mocks/content';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="scroll-mt-nav py-12 md:py-16">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="text-center">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 flex items-center justify-center gap-2">
              <i className="ri-question-answer-line text-primary-500"></i>
              常见问题
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              关于本站内容范围与使用方式的说明，点击任意问题即可展开查看。
            </p>
          </div>

          <div className="mt-8 flex flex-col gap-3">
            {faqs.map((item, index) => {
              const open = openIndex === index;
              return (
                <div
                  key={item.q}
                  className="rounded-lg border border-background-200 bg-background-50 overflow-hidden"
                >
                  <button
                    type="button"
                    aria-expanded={open}
                    onClick={() => setOpenIndex(open ? -1 : index)}
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  >
                    <span className="text-sm md:text-base font-bold text-foreground-950">{item.q}</span>
                    <i
                      className={`flex-shrink-0 text-lg text-primary-600 ${
                        open ? 'ri-subtract-line' : 'ri-add-line'
                      }`}
                    ></i>
                  </button>
                  {open && (
                    <div className="px-5 pb-4 -mt-1">
                      <p className="text-sm leading-relaxed text-foreground-700">{item.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}